import i18n from '@/i18n';

export function subscriptionNoticeText(notice) {
  if (!notice) return null;

  const t = i18n.global.t;
  const date = notice.end_date ? new Date(notice.end_date).toLocaleDateString() : '';

  if (notice.expired) {
    return t('subscription.notice.expired');
  }
  if (notice.days_left != null && notice.days_left < 0) {
    return t('subscription.notice.grace', { date });
  }
  if (notice.due_soon) {
    return t('subscription.notice.dueSoon', { date, days: notice.days_left });
  }
  return null;
}
